import  React, { useState, useRef, useEffect, useContext  } from "react";
import { useParams } from 'react-router-dom';
import * as RecordRTC from 'recordrtc';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icons } from "../assest/icons";
import { logger } from '../utils/logger';
import Header from './header';
import moment from 'moment'; 
import { ToastContainer, toast } from "react-toastify"; 
import axios from 'axios';   
import LoaderSpinner from './loaderSpinner'; 
import { SearchContext } from './admin/SearchContext'; 
import Modal from 'react-modal';
import HeightFormatter, { formatHeight } from './HeightFormatter';
import {
  getUserSessions,
  getInsuranceData,
  getIllnesses,
  getMedicalReports,
  getPCPPharmacyDetails,
  getPCPPharmacyByUserId,
  getAllFollowupRequests,
  getActiveFollowupRequest,
  createAdminLog,
  updateChatSession
} from '../services/firestore';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase.config';
import html2pdf from "html-to-pdf-js";
import { PDFDocument } from "pdf-lib";
import { fetchWithAppCheck } from '../utils/fetchWithAppCheck';

// Assessment & Plan PDF imports
import AbdominalCT from '../assest/document/AIGICare_PDF_AbdominalCT.pdf';
import AbdominalUS from '../assest/document/AIGICare_PDF_AbdominalUS.pdf';
import AnemiaLabs from '../assest/document/AIGICare_PDF_AnemiaLabs.pdf';
import BariumStudies from '../assest/document/AIGICare_PDF_BariumStudies.pdf';
import BasicGastroLabs from '../assest/document/AIGICare_PDF_BasicGastroLabs.pdf';
import ColonOrder from '../assest/document/AIGICare_PDF_Colon_Order.pdf';
import Colonoscopy from '../assest/document/AIGICare_PDF_Colonoscopy.pdf';
import ColonScreeningGuidelines from '../assest/document/AIGICare_PDF_ColonScreeningGuidelines.pdf';
import Diverticulosis from '../assest/document/AIGICare_PDF_Diverticulosis.pdf';
import EGDOrder from '../assest/document/AIGICare_PDF_EGD_Order.pdf';
import FattyLiver from '../assest/document/AIGICare_PDF_FattyLiver.pdf';
import GERD_Diet_and_Lifestyle from '../assest/document/AIGICare_PDF_GERD_Diet_and_Lifestyle.pdf';
import HeapticLabs from '../assest/document/AIGICare_PDF_HeapticLabs.pdf';
import High_Fiber_Diet from '../assest/document/AIGICare_PDF_High_Fiber_Diet.pdf';
import InflammatoryBowelDisease from '../assest/document/AIGICare_PDF_InflammatoryBowelDisease.pdf';
import IrritableBowelSyndrome from '../assest/document/AIGICare_PDF_IrritableBowelSyndrome.pdf';
import ProceduralSedation from '../assest/document/AIGICare_PDF_ProceduralSedation.pdf';
import StoolStudies from '../assest/document/AIGICare_PDF_StoolStudies.pdf';
import StressManagement from '../assest/document/AIGICare_PDF_StressManagement.pdf';
import TelehealthDisclaimer from '../assest/document/AIGICare_PDF_TelehealthDisclaimer.pdf';
import UpperGIEndoscopy from '../assest/document/AIGICare_PDF_UpperGIEndoscopy.pdf';
import Weight_Reducing_Diet from '../assest/document/AIGICare_PDF_Weight_Reducing_Diet.pdf';

import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

// Set the app element for accessibility (react-modal requirement)
Modal.setAppElement('#root');

// Extracts a section from the chatbot AI summary text by keyword(s)
const extractChatbotSection = (summary, ...keywords) => {
  if (!summary) return '';
  const lines = summary.split('\n');
  let capturing = false;
  const result = [];
  // Matches any ALL-CAPS section header (e.g. "ALLERGIES:", "CURRENT MEDICATIONS: text")
  const anySectionHeader = /^[A-Z][A-Z\s,/&()+\-]{3,}:/;
  for (const line of lines) {
    const trimmed = line.trim();
    // Check if this line matches one of our target keyword headers
    if (keywords.some(kw => new RegExp('^' + kw + '\\s*:', 'i').test(trimmed))) {
      capturing = true;
      // Also capture any content that appears after the colon on the same line
      const colonIdx = trimmed.indexOf(':');
      if (colonIdx !== -1) {
        const afterColon = trimmed.slice(colonIdx + 1).trim();
        if (afterColon) result.push(afterColon);
      }
      continue;
    }
    // Stop when we hit any other ALL-CAPS section header
    if (capturing && anySectionHeader.test(trimmed)) break;
    if (capturing && trimmed) result.push(line);
  }
  return result.join('\n').trim();
};

const renderAISummary = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  const elements = [];

  const renderBold = (line) => {
    const parts = line.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, idx) => idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part);
  };

  lines.forEach((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    if (/^THERAPIES\s*:/i.test(trimmed)) return;
    if (/^\d+\.\s+/.test(trimmed) || /^[A-Z][A-Z\s,/&]+:/.test(trimmed)) {
      const cleanedTrimmed = trimmed.replace(/^\d+[\.\)]\s*/, '');
      const colonIdx = cleanedTrimmed.indexOf(':');
      const headingPart = colonIdx !== -1 ? cleanedTrimmed.slice(0, colonIdx + 1) : cleanedTrimmed;
      const descPart = colonIdx !== -1 ? cleanedTrimmed.slice(colonIdx + 1).trim() : '';
      elements.push(
        <div key={`h-${i}`} style={{marginTop:'14px', marginBottom:'5px', borderBottom:'1px solid #e3eaf5', paddingBottom:'3px'}}>
          <span style={{fontWeight:'700', color:'#024C9C', fontSize:'14px'}}>{renderBold(headingPart)}</span>
          {descPart && <span style={{fontWeight:'400', color:'#222', fontSize:'14px'}}> {renderBold(descPart)}</span>}
        </div>
      );
    } else if (/^[•\-]\s+/.test(trimmed)) {
      const cleanLine = trimmed.replace(/^[•\-]\s+/, '');
      if (cleanLine) elements.push(
        <div key={`b-${i}`} style={{display:'flex', alignItems:'flex-start', margin:'4px 0 4px 8px', lineHeight:'1.6'}}>
          <span style={{marginRight:'8px', color:'#024C9C', fontWeight:'700'}}>•</span>
          <span>{renderBold(cleanLine)}</span>
        </div>
      );
    } else {
      const cleanLine = trimmed.replace(/^\*+\s*/, '');
      if (cleanLine) elements.push(<p key={`p-${i}`} style={{margin:'3px 0 3px 4px', lineHeight:'1.5'}}>{renderBold(cleanLine)}</p>);
    }
  });
  return <div style={{fontSize:'13.5px'}}>{elements}</div>;
};

function PatientHistory() {
  const { sessionIDNew } = useParams();

  

 const userProfileData =  JSON.parse(localStorage.getItem('UserProfile')) || {};
  const [myinsuranceinfo, setMyinsuranceinfo] = useState([]);  
  const [CheckExpiry, setCheckExpiry] = useState(false);  
  const [UserId, setUserId] = useState(userProfileData?.id || userProfileData?.user_id || JSON.parse(localStorage.getItem('UserId')) || '');
  const [GenderTxt, setGenderTxt] = useState(userProfileData?.gender || '');
  var years = moment().diff(userProfileData?.dob || '');
  const [AgeTxt, setAgeTxt] = useState(years);
  const [fullName, setFullName] = useState(userProfileData?.fullName || 'User');
  const [email, setEmail] = useState(userProfileData?.email || '');
  const [phoneNumber, setPhoneNumber] = useState(userProfileData?.phoneNumber || '');
  const [DOBTxt, setDOBTxt] = useState(userProfileData?.dob || '');
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingCD, setIsEditingCD] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  var years = moment().diff(DOBTxt || '');
  const ageCal = DOBTxt ? moment().diff(DOBTxt, 'years') : 0;    

  // const [userProfileData, setUserProfileData] = useState(JSON.parse(localStorage.getItem('UserProfile')));

// --------------------------------------------------



let navigate = useNavigate();
const routeChange = () => { 
  navigate('/admin/dashboard', {
     state: {backCurrentPage: backCurrentPage, searchTxt: searchTxtCheck }
  
  }); 
}
const handleBackButton = () => { 
   navigate('/dashboard', { state: { currentPage: currentPage } });
  //  navigate('/dashboardview', { state: { backCurrentPage: currentPage } });
};
const newappointmentLink = () => { 
  if(CheckExpiry){
    // navigate('/myinsurance'); 
    navigate('/newappointment'); 

  }else{
    navigate('/newappointment'); 
  }

}

const location = useLocation(); 
const [ShowLoaderPage, setShowLoaderPage] = useState(false);
const [userid, setuserid] = useState(UserId); 
const [adminId, setAdminId] = useState(JSON.parse(localStorage.getItem('UserIdAdmin'))); 

const [searchTxtCheck, setSearchTxtCheck] = useState('');
const [backCurrentPage, setcurrentPageNo] = useState('');
const [UserHistoryData, setUserHistoryData] = useState([]);
const [patientHistorySession, setPatientHistorySession] = useState([]);
const [UserHistoryNumber, setUserHistoryNumber] = useState('');
const [ChatHistory, setChatHistory] = useState([]);
const [RecordData, setRecordData] = useState([]);  
const [BackReload, setBackReload] = useState(false);     
const [userProfile, setUserProfile] = useState('');  
const [specialty, setSpecialty] = useState('');
const [selectedToggle, setSelectedToggle] = useState(true); 
const [InsuranceIdTxt, setInsuranceIdTxt] = useState(''); 
const [originalProfile, setOriginalProfile] = useState({});   
var years = moment().diff(DOBTxt); 
const [BMITxt, setBMITxt] = useState('');   
 
const [WeightTxt, setWeightTxt] = useState('');
const [HeightTxt, setHeightTxt] = useState('');
const [ShowLoader, setShowLoader] = useState(false); 
 
const [showCalendar, setShowCalendar] = useState(false);  
const [isValid, setIsValid] = useState(false);
const [isSession, setIsSession] = useState(false);

const [currentPage, setCurrentPage] = useState(1);
const [recordsPerPage, setRecordsPerPage] = useState(10);
const [showSummay, setShowSummary] = useState(false);
const totalPages = Math.ceil(UserHistoryData.length / recordsPerPage);
const totalPageGroups = Math.ceil(totalPages / 3);
const currentPageGroup = Math.ceil(currentPage / 3);

const [illnessesList, setIllnessesList] = useState([]);
const [selectedIllness, setSelectedIllness] = useState(null);
const [answerLoader, setAnswerLoader] = useState(false);
const [EmergencyQuest, setEmergencyQuest] = useState(false);

const [activeTab, setActiveTab] = useState(0);
const { searchQuery } = useContext(SearchContext);

const [MainPointsDiscussed, setMainPointsDiscussed] = useState('');
const [PlanOnCareData, setPlanOnCareData] = useState('');
const [ConditionalDiagnosis, setConditionalDiagnosis] = useState('');

const [SessionIDCheck, setSessionIDCheck] = useState('');
const [reportData, setReportData] = useState(null);
const [checkFollowupMeet, setCheckFollowupMeet] = useState(false); 
const [checkAllFollowupMeet, setCheckAllFollowupMeet] = useState(false); 

useEffect(() => {
  if (UserId) {
    setuserid(UserId);
  }
}, [UserId]);
const [selectedItemFollowup, setSelectedItemFollowup] = useState([]); // Followup Date   
const [checkPhysicalExam, setCheckPhysicalExam] = useState(false); // Track if the div is open
const [bpMMTxt, setbpMMTxt] = useState('');
const [bpHgTxt, setbpHgTxt] = useState('');
const [heartrateTxt, setheartrateTxt] = useState('');
const [selectedItem, setSelectedItem] = useState(null); // Button name
const [openDiv, setOpenDiv] = useState(null);
const [followupZoomMeet, setFollowupZoomMeet] = useState(false);
const [followupMeetingDone, setFollowupMeetingDone] = useState(false);
const [checkZoomMeet, setCheckZoomMeet] = useState(false); 
const [selectedZoomMeet, setSelectedZoomMeet] = useState([]); // Button name    
const [isOpenFollowup, setIsOpenFollowup] = useState(false); // Track if the div is open
const [checkFollowup, setCheckFollowup] = useState(false); // Track if the div is open
const [filledCheckFollowup, setfilledCheckFollowup] = useState(false); // Track if the div is open
const [followupDays, setFollowupDays] =  useState(new Date()); //useState('');
const [futureDate, setFutureDate] = useState(null);
const [remainingDays, setRemainingDays] = useState(null);
const now = new Date();
const [errorMessage, setErrorMessage] = useState('');

// console.log(followupZoomMeet +'  -  '+ selectedItemFollowup +'  -  '+ JSON.stringify(selectedZoomMeet))

const [errors, setErrors] = useState({}); 
const [activeSpeech, setActiveSpeech] = useState(null);
const [transcripts, setTranscripts] = useState({ medicalcondition: ''});
const { transcript, resetTranscript, listening, browserSupportsSpeechRecognition } = useSpeechRecognition();
const socket = useRef(null);
const recorder = useRef(null);
const streamRef = useRef(null);
const [isRecording, setIsRecording] = useState({medicalcondition: false,});
const [activeMic, setActiveMic] = useState(null); 
const [isConnecting, setIsConnecting] = useState(false);
const [MedicalConditionsData, setMedicalConditionsData] = useState('');
const [MedicalConditionFile, setMedicalConditionFile] = useState(null);
const [fileNameMedicalCondition, setFileNameMedicalCondition] = useState('');
const [medicalConditionSuggestions, setMedicalConditionSuggestions] = useState([]); 
 
const [FollowupData, setFollowupData] = useState([]); // Followup Date 

const [followSummaryFollowup, setFollowSummaryFollowup] = useState('');
const [summaryAIChatbot, setSummaryAIChatbot] = useState('');
const [isGeneratingSummary, setIsGeneratingSummary] = useState(false);
const [zoomSummaryData, setZoomSummaryData] = useState('');
const [zoomDiagnosisData, setZoomDiagnosisData] = useState('');
const [zoomPlanData, setZoomPlanData] = useState('');
const [zoomHPI, setZoomHPI] = useState('');
const [zoomPMH, setZoomPMH] = useState('');
const [zoomMedications, setZoomMedications] = useState('');
const [zoomAllergies, setZoomAllergies] = useState('');
const [zoomSocialHistory, setZoomSocialHistory] = useState('');
const [zoomROS, setZoomROS] = useState('');
const [finalConsultantNote, setFinalConsultantNote] = useState('');
const [finalConsultantDiagnosis, setFinalConsultantDiagnosis] = useState('');
const [finalConsultantPlan, setFinalConsultantPlan] = useState('');
const [finalConsultantHPI, setFinalConsultantHPI] = useState('');
const [finalConsultantPMH, setFinalConsultantPMH] = useState('');
const [finalConsultantMedications, setFinalConsultantMedications] = useState('');
const [finalConsultantAllergies, setFinalConsultantAllergies] = useState('');
const [finalConsultantSocialHistory, setFinalConsultantSocialHistory] = useState('');
const [finalConsultantROS, setFinalConsultantROS] = useState('');
const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
const [selectedFinalNoteFiles, setSelectedFinalNoteFiles] = useState([]);
const [doctorRecommendations, setDoctorRecommendations] = useState([]);
const [isFinalNoteSubmitted, setIsFinalNoteSubmitted] = useState(false);
const [patientReportHistory, setPatientReportHistory] = useState([]);
const [selectedPatientReportVersion, setSelectedPatientReportVersion] = useState(null);
const [submittedByName, setSubmittedByName] = useState('');
const [submittedBySpecialty, setSubmittedBySpecialty] = useState('');
const [submittedByPhone, setSubmittedByPhone] = useState('');
const [submittedBySignature, setSubmittedBySignature] = useState('');
const finalNoteContentRef = useRef();

const assessmentFileCategories = [
  { category: 'Labs', files: [
    { id: 5, fileName: 'Basic Gastro Labs', url: BasicGastroLabs },
    { id: 3, fileName: 'Anemia Labs', url: AnemiaLabs },
    { id: 14, fileName: 'Heaptic Labs', url: HeapticLabs },
    { id: 19, fileName: 'Stool Studies', url: StoolStudies },
  ]},
  { category: 'Imaging', files: [
    { id: 1, fileName: 'Abdominal CT', url: AbdominalCT },
    { id: 2, fileName: 'Abdominal US', url: AbdominalUS },
    { id: 4, fileName: 'Barium Studies', url: BariumStudies },
  ]},
  { category: 'Procedure', files: [
    { id: 10, fileName: 'EGD Order', url: EGDOrder },
    { id: 6, fileName: 'Colon Order', url: ColonOrder },
    { id: 7, fileName: 'Colonoscopy', url: Colonoscopy },
    { id: 22, fileName: 'Upper GI Endoscopy', url: UpperGIEndoscopy },
    { id: 18, fileName: 'Procedural Sedation', url: ProceduralSedation },
    { id: 8, fileName: 'Colon Screening Guidelines', url: ColonScreeningGuidelines },
    { id: 21, fileName: 'Telehealth Disclaimer', url: TelehealthDisclaimer },
  ]},
  { category: 'Diet & Lifestyle Modification', files: [
    { id: 23, fileName: 'Weight Reducing Diet', url: Weight_Reducing_Diet },
    { id: 15, fileName: 'High Fiber Diet', url: High_Fiber_Diet },
    { id: 13, fileName: 'GERD and Lifestyle', url: GERD_Diet_and_Lifestyle },
    { id: 20, fileName: 'Stress Management', url: StressManagement },
    { id: 11, fileName: 'FattyLiver', url: FattyLiver },
    { id: 9, fileName: 'Diverticulosis', url: Diverticulosis },
    { id: 17, fileName: 'Irritable Bowel Syndrome', url: IrritableBowelSyndrome },
    { id: 16, fileName: 'Inflammatory Bowel Disease', url: InflammatoryBowelDisease },
  ]},
];
const assessmentFileArray = assessmentFileCategories.flatMap((cat) => cat.files);
const [isGeneratingZoomSummary, setIsGeneratingZoomSummary] = useState(false);
const [reportIDForAll, setReportIDForAll] = useState('');

const [activeOption, setActiveOption] = useState('Routine'); // State to track the active option
const [PCP_Pharmacy, setPCP_Pharmacy] = useState(null);

const getInitials = (name) => {
  if (!name || typeof name !== 'string') return 'U';
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase())
    .join('') || 'U';
};
 
const handleOptionClick = (option) => {
  setActiveOption(option); // Update the active option
};

const formatConsultationDate = (createdOn, createdAt) => {
  const dateValue = createdOn || createdAt;
  if (!dateValue) return '-';
  const value = moment(dateValue);
  return value.isValid() ? value.format('MMM DD, YYYY') : '-';
};



const checkOrderList = [
  { Name: "Allergies", doc_type: "allergy" },
  { Name: "Medications", doc_type: "medications" },
  { Name: "Medical Conditions", doc_type: "medical_conditions" },
  { Name: "Past Surgical History", doc_type: "past_surgical_history" },
  { Name: "Social History", doc_type: "social_history" },
  { Name: "Primary Care Physician (PCP)", doc_type: "pcp" },
  { Name: "Pharmacy information", doc_type: "pharmacy" },
  { Name: "Upload Reports", doc_type: "other_report" }
];

const options = [
  'Test Results',
  'Refills',
  'Recall Colon',
  'Recall ECD',
  'Routine',
  'Persistant Symptoms',
];

useEffect(() => {
  if (!sessionIDNew) return;
  const parsedPage = Number(sessionIDNew.split('-')[1] || 1);
  if (Number.isFinite(parsedPage) && parsedPage > 0) {
    setCurrentPage(parsedPage);
  }
}, [sessionIDNew]);

const toggleDivFollowup = () => {
  setCheckFollowup(false);    
  setOpenDiv(openDiv === 'Followup' ? null : 'Followup');
};

// Handle cancel button click
const closeFollowup = () => {
  setCheckFollowup(false); // Close the div without saving  
    setOpenDiv('') 
    setErrors({});       
    setErrorMessage(''); 
};
 // Handle cancel button click
 const handleCancelFollowup = () => {
  setIsOpenFollowup(false); // Close the div without saving 
    // Reset temporary input values 
    setFollowupDays(''); 
    setFutureDate('');
    setOpenDiv('')
    // Clear any errors
    setErrors({}); 
    setErrorMessage('');
    setLoading(false);
};
 
  // Handle form submission
  const handleSaveFollowup = async (event) => { 
    event.preventDefault();
    setLoading(true);
  
    let formErrors = {};
    // setErrorMessage('');
  
    // if (!followupDays.trim()) {
   if (!followupDays || (typeof followupDays === 'string' && !followupDays.trim())) {
    formErrors.followupDays = 'Please enter follow-up days';
    }
  
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setLoading(false);
      return;
    }
  
    setShowLoader(true);
  
    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      follow_up_date: followupDays,
    };
  
    try {
      await updateChatSession(SessionIDCheck, { follow_up_date: followupDays });
      toast.success('Data updated successfully!', { position: toast.POSITION.TOP_RIGHT });
      setSelectedItemFollowup(futureDate);
      setFollowupDays('');
      setFutureDate('');
      setOpenDiv(null);
      setErrors({});
      setLoading(false);
      setShowLoader(false);
    } catch (error) {
      logger.error('Error:', error);
      toast.error('Network error. Please try again later.', { position: toast.POSITION.TOP_RIGHT });
      setLoading(false);
      setShowLoader(false);
    }
  };
 
useEffect(() => {
if (searchQuery) {
  navigate('/admin/dashboard');
}
}, [searchQuery, navigate]);

// Fetch illnesses
const illnessesArray = async () => {
  try {
    const illnesses = await getIllnesses();
    setIllnessesList(illnesses);
  } catch (error) {
    logger.error('Error fetching illnesses:', error);
  }
};

const handleRecordsPerPageChange = (event) => {
setRecordsPerPage(Number(event.target.value));
setCurrentPage(1);
};

const handlePageChange = (page) => {
setCurrentPage(page);
};

const handleNextGroup = () => {
if (currentPage < totalPages) {
  setCurrentPage(currentPage + 1);
}
};

const handlePrevGroup = () => {
if (currentPage > 1) {
  setCurrentPage(currentPage - 1);
}
};

const handleFindRecord = (id) => {

};
// Group reportData by doc_type
const groupedDocuments = (reportData || []).reduce((acc, doc) => {
  if (!doc.doc_type) {
    return acc;
  }
  const docType = doc.doc_type.trim();

  if (!acc[docType]) {
    acc[docType] = [];
  }

  acc[docType].push({
    doc_id: doc.doc_id,
    doc_summary: doc.doc_summary,
    doc_text: doc.doc_text,
    doc_url: doc.doc_url,
  });


return acc;
}, {});


if (PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name) {
  const pcpParts = [
    PCP_Pharmacy.pcp.name,
    PCP_Pharmacy.pcp.address,
    PCP_Pharmacy.pcp.phone ? `Phone: ${PCP_Pharmacy.pcp.phone}` : null,
    PCP_Pharmacy.pcp.fax ? `Fax: ${PCP_Pharmacy.pcp.fax}` : null,
  ].filter(Boolean);
  groupedDocuments["pcp"] = [
    ...(groupedDocuments["pcp"] || []),
    {
      doc_summary: pcpParts.join(', '),
      doc_text: null,
      doc_url: null,
    },
  ];
  }
  // Push Pharmacy into groupedDocumentspharmacy
  if (PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name) {
  const pharmacyParts = [
    PCP_Pharmacy.pharmacy.name,
    PCP_Pharmacy.pharmacy.address,
    PCP_Pharmacy.pharmacy.phone ? `Phone: ${PCP_Pharmacy.pharmacy.phone}` : null,
    PCP_Pharmacy.pharmacy.fax ? `Fax: ${PCP_Pharmacy.pharmacy.fax}` : null,
  ].filter(Boolean);
  groupedDocuments["pharmacy"] = [
    ...(groupedDocuments["pharmacy"] || []),
    {
       doc_summary: pharmacyParts.join(', '),
       doc_text: null,
       doc_url: null,
    },
  ];
  }  

// Map checkOrderList to match groupedDocuments and sort by order
const sortedGroupedDocuments = checkOrderList.map(orderItem => ({
Name: orderItem.Name,
doc_type: orderItem.doc_type,
documents: groupedDocuments[orderItem.doc_type] || []
}));

const adminCheckedSession = async (patientId, sessionId) => {
try {
  await createAdminLog({ patient_id: patientId, admin_id: adminId, session_id: sessionId });
  setBackReload(true);
} catch (error) {
  logger.error('Error fetching data:', error);
  setShowLoader(false);
}
}

const handleShowChat = (id) => {
const filteredConversation = Array.isArray(RecordData?.conversation)
  ? RecordData.conversation.filter((convo) => Object.keys(convo).length !== 0)
  : [];

setActiveTab(id);
setAnswerLoader(true)
setTimeout(() =>  { 
  setChatHistory(filteredConversation); 
  setAnswerLoader(false) 
}, 1000);
}
const handleGenerateZoomSummary = async () => {
  const sessionId = RecordData?.session_id;
  const userId = RecordData?.user_id || UserId;
  if (!sessionId || !userId) {
    toast.error('Session not found.');
    return;
  }
  setIsGeneratingZoomSummary(true);
  try {
    const response = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateZoomCombinedSummary', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        user_id: userId,
        existing_summary: summaryAIChatbot || '',
        existing_diagnosis: ConditionalDiagnosis || '',
        existing_plan: PlanOnCareData || '',
      }),
    });
    const data = await response.json();
    if (data.chatbot_summary) {
      setZoomSummaryData(data.chatbot_summary);
      setZoomDiagnosisData(data.conditional_diagnosis || '');
      setZoomPlanData(data.plan_of_care || '');
      toast.success('Zoom consultation summary generated!', { position: toast.POSITION.TOP_RIGHT });
    } else {
      toast.error(data.error || 'Failed to generate summary.', { position: toast.POSITION.TOP_RIGHT });
    }
  } catch (err) {
    toast.error('Failed to generate zoom summary. Please try again.', { position: toast.POSITION.TOP_RIGHT });
  }
  setIsGeneratingZoomSummary(false);
};

const handleHideSummary = () => {
setActiveTab(0);
setRecordData([])
setSelectedIllness() 

if(BackReload){
  window.location.reload(); 
}
setShowSummary(false)
setAnswerLoader(false) 
setEmergencyQuest(false)
};

const handleShowDashboard = () => {
setShowSummary(false)
};

const renderPagination = () => {
let pages = [];
const startPage = (currentPageGroup - 1) * 3 + 1;
const endPage = Math.min(startPage + 2, totalPages);

for (let i = startPage; i <= endPage; i++) {
  pages.push(
    <button
      key={i}
      className={`page-button ${i === currentPage ? 'active' : ''}`}
      onClick={() => handlePageChange(i)}
    >
      {i}
    </button>
  );
}

return (
  <div className="pagination">
    <button
      onClick={handlePrevGroup}
      disabled={currentPage === 1}
    >
      Previous
    </button>
    {pages}
    <button
      onClick={handleNextGroup}
      disabled={currentPage === totalPages}
    >
      Next
    </button>
  
  </div>
);
};


useEffect(() => {
const fetchRecords = async () => {
const sessionid = sessionIDNew ? (sessionIDNew.split('-')[0] || '') : '';
if (!userid || !sessionid) {
  return;
}

setShowLoaderPage(true) 
  try {
    const sessionData = await getUserSessions(userid);
 if (sessionData){
    const normalizedHistory = (sessionData.history || []).map((item) => ({
      ...item,
      session_id: item.session_id || item.id || '',
      created_on: item.created_on || item.created_at || null
    }));
    const { user_details, session_status, bmi } = sessionData;
     // const foundRecordChk = response.data.history.find((item) => item.session_id === sessionid); 
    const foundRecordChk = normalizedHistory.find((item) => item.session_id === sessionid);
    // if (!foundRecordChk) throw new Error("Session not found");
      // Check if foundRecordChk exists
      if (!foundRecordChk) {
        logger.error("Session not found for sessionid:", sessionid);
        // Optionally set a state to display a user-friendly message
        setRecordData(null);
        setShowLoaderPage(false); // Stop loader as there's no further action
        return;
      }
    setPatientHistorySession(foundRecordChk) 
    setSessionIDCheck(foundRecordChk.session_id)  
      
   


    // Set user profile data
  // setUserProfileData(response.data.user_details);

  // Sort history data by created_on date in descending order
    const sortedHistory = [...normalizedHistory]
      .sort((a, b) => {
        const aDate = new Date(a.created_on || a.created_at || 0);
        const bDate = new Date(b.created_on || b.created_at || 0);
        return bDate - aDate;
      });
    setUserHistoryData(sortedHistory);
    setUserHistoryNumber(sortedHistory.length) ; 

    setBMITxt(bmi|| 0);
    setFullName(user_details.fullName);
    setEmail(user_details.email);
    setDOBTxt(user_details.dob);
    setPhoneNumber(user_details.phoneNumber ? (user_details.phoneNumber.startsWith('+') ? user_details.phoneNumber : '+' + user_details.phoneNumber) : '');
    setUserProfile(user_details.userProfile);
    setInsuranceIdTxt(user_details.insurance || 0);
    setGenderTxt(user_details.gender || '');
    setHeightTxt(user_details.height || 0);
    setWeightTxt(user_details.weight || 0);        
    setIsSession(session_status || 'false');
   

    const foundRecord = foundRecordChk;
  //  UserHistoryData.find((item) => item.session_id === id);  

 

  setRecordData(foundRecord);
  // Process conversation data
  const filteredConversation = foundRecordChk.conversation
  ? foundRecordChk.conversation.filter((convo) => Object.keys(convo).length !== 0)
  : [];
  setChatHistory(filteredConversation);


  setSelectedIllness(foundRecord.illness) 
  // setChatHistory(filteredConversation)  
  const isOldQAFormat = (s) => s && s.trim().startsWith('Patient Presenting Symptom:');
  const aiSummary = isOldQAFormat(foundRecord.chatbot_summary) ? '' : (foundRecord.chatbot_summary || '');
  setSummaryAIChatbot(aiSummary)
  setPlanOnCareData(foundRecord.plan_of_care || '')
  setConditionalDiagnosis(foundRecord.conditional_diagnosis || '');
  setSessionIDCheck(sessionid) 
  // setSelectedItemFollowup(foundRecord.follow_up_date || '')
  setCheckPhysicalExam(foundRecord.bp_hg ? 'true'  : 'false')
  setbpHgTxt(foundRecord.bp_hg || '')
  setbpMMTxt(foundRecord.bp_mm || '')
  setheartrateTxt(foundRecord.heartrate || '')
  setSelectedItem(foundRecord.patientstatus)
  setSelectedZoomMeet(foundRecord.zoom_meeting || null)
  setZoomSummaryData(foundRecord.zoom_summary || '');
  setZoomDiagnosisData(foundRecord.zoom_conditional_diagnosis || '');
  setZoomPlanData(foundRecord.zoom_plan_of_care || '');
  setZoomHPI(foundRecord.zoom_hpi || '');
  setZoomPMH(foundRecord.zoom_pmh || '');
  setZoomMedications(foundRecord.zoom_medications || '');
  setZoomAllergies(foundRecord.zoom_allergies || '');
  setZoomSocialHistory(foundRecord.zoom_social_history || '');
  setZoomROS(foundRecord.zoom_ros || '');
  setFinalConsultantNote(foundRecord.final_consultant_note || '');
  setFinalConsultantDiagnosis(foundRecord.final_consultant_diagnosis || '');
  setFinalConsultantPlan(foundRecord.final_consultant_plan || '');
  setFinalConsultantHPI(foundRecord.final_consultant_hpi || '');
  setFinalConsultantPMH(foundRecord.final_consultant_pmh || '');
  setFinalConsultantMedications(foundRecord.final_consultant_medications || '');
  setFinalConsultantAllergies(foundRecord.final_consultant_allergies || '');
  setFinalConsultantSocialHistory(foundRecord.final_consultant_social_history || '');
  setFinalConsultantROS(foundRecord.final_consultant_ros || '');
  setDoctorRecommendations(foundRecord.doctor_recommendations || []);
  setIsFinalNoteSubmitted(foundRecord.is_final_note_submitted || false);
  setSubmittedByName(foundRecord.submitted_by_name || '');
  setSubmittedBySpecialty(foundRecord.submitted_by_specialty || '');
  setSubmittedByPhone(foundRecord.submitted_by_phone || '');
  setSubmittedBySignature(foundRecord.submitted_by_signature || '');
  setReportIDForAll(foundRecord.reports_id || null)

  // Load selected Assessment & Plan files
  const savedFileIds = foundRecord?.selected_final_note_file_ids || [];
  if (savedFileIds.length > 0) {
    const restoredFiles = assessmentFileArray.filter((f) => savedFileIds.includes(f.id));
    setSelectedFinalNoteFiles(restoredFiles);
  } else {
    setSelectedFinalNoteFiles([]);
  }

 // Check for emergency care
      const emergencyQuestion = filteredConversation.find(
        (convo) =>
          convo.question === "Do you need emergency care? (YES/NO)" &&
          (convo.answer || '').toLowerCase() === "yes"
      );
  
  if (emergencyQuestion) {
    // alert("Emergency care is needed!");
    setEmergencyQuest(true)
  } 
  setChatHistory([]);
  setShowSummary(true);

  // Auto-generate AI summary if no real AI summary yet (missing or old Q&A format)
  if ((!foundRecord.chatbot_summary || isOldQAFormat(foundRecord.chatbot_summary)) && filteredConversation.length > 0) {
    setIsGeneratingSummary(true);
    fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateAISummary', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: foundRecord.session_id, user_id: foundRecord.user_id || UserId }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.chatbot_summary) {
          setSummaryAIChatbot(data.chatbot_summary);
          setPlanOnCareData(data.plan_of_care || '');
          setConditionalDiagnosis(data.conditional_diagnosis || '');
        }
      })
      .catch(err => logger.error('Auto-generate AI summary error:', err))
      .finally(() => setIsGeneratingSummary(false));
  }

  // Call dependent functions
  fetchPatientHistory(sessionid, foundRecord.reports_id);
  loadPatientReportHistory(foundRecord.session_id);
} else {
  logger.error("Invalid session data or missing history");
}

 
  } catch (error) {
    logger.error('Error fetching records:', error);
    // Handle error, show an error message, etc.
  } 
};
fetchRecords();
}, [userid, sessionIDNew]);

const fetchPatientHistory = async (newSessionid, newReportIDChk) => {  
  //  UserHistoryData.find((item) => item.session_id === id);  
 
try {
  const followupData = await getAllFollowupRequests(newSessionid);
  if (Array.isArray(followupData) && followupData.length > 0) {
    setFollowupData(followupData);
  } else {
    setFollowupData([]);
  }

  } catch (error) {

  } finally {

  }

// Reset followup states before evaluating the active request
setFollowupZoomMeet(false);
setFollowupMeetingDone(false);

try {
  const activeRequest = await getActiveFollowupRequest(newSessionid);
  if (activeRequest) {
    const { activeFlag, data } = activeRequest;
    setCheckAllFollowupMeet(activeFlag);
    setSelectedItemFollowup(data);
    if (data?.zoom_meeting && Object.keys(data.zoom_meeting).length > 0) {
      setFollowupZoomMeet(true);
      const ms = data.zoom_meeting.meeting_status;
      if (ms === 'completed' || ms === 'ended' || data.status === 'completed') {
        setFollowupMeetingDone(true);
      }
    }
    setCheckFollowupMeet(activeFlag);
  } else {
    setCheckAllFollowupMeet(false);
    setCheckFollowupMeet(false);
  }
  
  } catch (error) {
   
  } finally {
    
  }

try {
  const illnesses = await getIllnesses();
  setIllnessesList(illnesses);
} catch (error) {
  logger.error('Error fetching illnesses:', error);
}

// Only fetch reports if newReportIDChk exists
if (newReportIDChk) {
  try {
    const reports = await getMedicalReports(newReportIDChk, userid);
    setReportData(reports || []);
  } catch (error) {
    logger.error('Error fetching medical reports:', error);
  }
} else {
  setReportData(null);
}

// PCP/Pharmacy: try by this session's reports_id first, fallback to user_id
// so patient always sees their PCP even if not filled in this appointment
try {
  let pcpPharmacy = newReportIDChk ? await getPCPPharmacyDetails(newReportIDChk) : null;
  if (!pcpPharmacy) {
    pcpPharmacy = await getPCPPharmacyByUserId(UserId);
  }
  setPCP_Pharmacy(pcpPharmacy || null);
} catch (error) {
  logger.error('Error fetching PCP/Pharmacy details:', error);
  setPCP_Pharmacy(null);
}

setShowLoaderPage(false)

};

const loadPatientReportHistory = async (sessionId) => {
  if (!sessionId) return;
  try {
    const res = await fetchWithAppCheck(
      'https://us-central1-aigicare-prod.cloudfunctions.net/getReportHistory',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId }),
      }
    );
    const data = await res.json();
    if (data.versions && data.versions.length > 0) {
      const submittedVersions = data.versions.filter(v => v.submitted === true);
      setPatientReportHistory(submittedVersions);

      // If root doc is_final_note_submitted is false (e.g. after followup generation)
      // but there are previously submitted versions, show the latest submitted version
      if (submittedVersions.length > 0) {
        setIsFinalNoteSubmitted(true);
        const latestSubmitted = submittedVersions[0];
        setFinalConsultantNote(latestSubmitted.final_consultant_note || '');
        setFinalConsultantHPI(latestSubmitted.final_consultant_hpi || '');
        setFinalConsultantPMH(latestSubmitted.final_consultant_pmh || '');
        setFinalConsultantMedications(latestSubmitted.final_consultant_medications || '');
        setFinalConsultantAllergies(latestSubmitted.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(latestSubmitted.final_consultant_social_history || '');
        setFinalConsultantROS(latestSubmitted.final_consultant_ros || '');
      }
    }
  } catch (err) {
    logger.error('Error loading patient report history:', err);
  }
};

const handleViewPatientReportVersion = (version) => {
  if (!version) {
    setSelectedPatientReportVersion(null);
    // Restore latest submitted version's content (not root doc which may have unsubmitted data)
    if (patientReportHistory.length > 0) {
      const latestSubmitted = patientReportHistory[0];
      setFinalConsultantNote(latestSubmitted.final_consultant_note || '');
      setFinalConsultantHPI(latestSubmitted.final_consultant_hpi || '');
      setFinalConsultantPMH(latestSubmitted.final_consultant_pmh || '');
      setFinalConsultantMedications(latestSubmitted.final_consultant_medications || '');
      setFinalConsultantAllergies(latestSubmitted.final_consultant_allergies || '');
      setFinalConsultantSocialHistory(latestSubmitted.final_consultant_social_history || '');
      setFinalConsultantROS(latestSubmitted.final_consultant_ros || '');
    } else {
      const sid = sessionIDNew ? (sessionIDNew.split('-')[0] || '') : '';
      const rec = UserHistoryData.find(item => (item.session_id || item.id) === sid);
      if (rec) {
        setFinalConsultantNote(rec.final_consultant_note || '');
        setFinalConsultantHPI(rec.final_consultant_hpi || '');
        setFinalConsultantPMH(rec.final_consultant_pmh || '');
        setFinalConsultantMedications(rec.final_consultant_medications || '');
        setFinalConsultantAllergies(rec.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(rec.final_consultant_social_history || '');
        setFinalConsultantROS(rec.final_consultant_ros || '');
      }
    }
    return;
  }
  const item = patientReportHistory.find(h => h.version === parseInt(version));
  if (item) {
    setSelectedPatientReportVersion(parseInt(version));
    setFinalConsultantNote(item.final_consultant_note || '');
    setFinalConsultantHPI(item.final_consultant_hpi || '');
    setFinalConsultantPMH(item.final_consultant_pmh || '');
    setFinalConsultantMedications(item.final_consultant_medications || '');
    setFinalConsultantAllergies(item.final_consultant_allergies || '');
    setFinalConsultantSocialHistory(item.final_consultant_social_history || '');
    setFinalConsultantROS(item.final_consultant_ros || '');
  }
};

useEffect(() => {
const handlePopstate = () => {
  setActiveTab(0); // Reset the active tab to the default tab index
};

window.addEventListener('popstate', handlePopstate);

return () => {
  window.removeEventListener('popstate', handlePopstate);
};
}, []);

// Cleanup recorder, socket, and media stream on unmount
useEffect(() => {
  return () => {
    if (recorder.current) {
      recorder.current.stopRecording(() => { recorder.current = null; });
    }
    if (socket.current) {
      socket.current.close();
      socket.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  };
}, []);

const handleTabClick = (index) => {
setActiveTab(index);
setShowMainPoint(false);
};

useEffect(() => {
setActiveTab(0); // Set the default active tab when the component mounts
}, []);

const downloadFinalNotePdf = async () => {
  try {
    setIsGeneratingPdf(true);
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const sanitizedName = (fullName || 'Patient').replace(/ /g, "_");
    const filename = `${date}_${time}_${sanitizedName}_FinalNote`;
    const content = finalNoteContentRef.current;
    const headerImageUrl = Icons[0].headerImageUrlLink;
    const footerImageUrl = Icons[0].footerImageUrlLink;

    if (!content) {
      toast.error("Content not found!", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    const options = {
      margin: [1.47, 0.2, 1.1, 0.2],
      filename: filename,
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      html2canvas: { scale: 2, useCORS: true, letterRendering: true },
    };

    const contentPdfBlob = await html2pdf().set(options).from(content).toPdf().outputPdf('blob');
    const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());
    const mergedPdfDoc = await PDFDocument.create();

    const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
    contentPages.forEach((page) => mergedPdfDoc.addPage(page));

    // Add headers and footers
    const totalPages = mergedPdfDoc.getPageCount();
    const headerImageBytes = await fetch(headerImageUrl).then((r) => r.arrayBuffer());
    const footerImageBytes = await fetch(footerImageUrl).then((r) => r.arrayBuffer());
    const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
    const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

    for (let i = 0; i < totalPages; i++) {
      const page = mergedPdfDoc.getPage(i);
      const { width, height } = page.getSize();
      page.drawImage(headerImage, { x: 0, y: height - 50, width: width, height: 50 });
      page.drawText(`Page ${i + 1} of ${totalPages}`, { x: width - 70, y: height - 15, size: 10 });
      page.drawImage(footerImage, { x: 0, y: 0, width: width, height: 25 });
    }

    const mergedPdfBytes = await mergedPdfDoc.save();
    const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(mergedBlob);
    downloadLink.download = filename + '.pdf';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    toast.success("PDF downloaded!", { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    logger.error("Final note PDF error:", err);
    toast.error("Failed to generate PDF.", { position: toast.POSITION.TOP_RIGHT });
  } finally {
    setIsGeneratingPdf(false);
  }
};

// Function to process the user data
const processUserData = () => {
if (!RecordData) return []; // If no recordData, return empty array

return [RecordData].map(user => {
  // Remove empty objects from the conversation array
  const filteredConversation = Array.isArray(user?.conversation)
    ? user.conversation.filter((convo) => Object.keys(convo).length !== 0)
    : [];
  
  // Check if the answer to the specific question is "yes"
  const emergencyQuestion = filteredConversation.find(convo => 
    convo.question === "Do you need emergency care? (YES/NO)" && (convo.answer || '').toLowerCase() === "yes"
  );

  if (emergencyQuestion) {
    alert("Emergency care is needed!");
  }

  return {
    ...user,
    conversation: filteredConversation
  };
});
};
const [ImageHide, setImageHide] = useState(false); 
const [showMainPoint, setShowMainPoint] = useState(false);
const handleInputMainPoint = () => { 
    setShowMainPoint(false);   
    {!PlanOnCareData ? 
    (<>
      setShowMainPoint(false);
      </>
    ):(
      <>
      setShowMainPoint(true);
      </>
    )
  }
setShowMainPoint(true);
setPlanOnCareData(PlanOnCareData);
};
const handleCancelClickMPoint = () => {
setShowLoader(false);
setShowMainPoint(false);
};
const handleInputChangeMPoint= (e) => {
setPlanOnCareData(e.target.value);
};
const handleSaveClickMPoint = () => {
setShowLoader(true);
setTimeout(() => { 
setIsEditing(false); 
handleSaveMPoint();
}, 2000); 
};
const handleSaveMPoint = async (event) => {   
try {   
  const reqData = JSON.stringify({ session_id: SessionIDCheck, plan_of_care: PlanOnCareData }) ;

  await updateChatSession(SessionIDCheck, { plan_of_care: PlanOnCareData });
  setShowLoader(false);
  setShowMainPoint(false);
  setBackReload(true);
} catch (error) {
  logger.error('Error updating summary:', error);
  // Handle error, show an error message, etc.
}
};

const [showMainPointCD, setShowMainPointCD] = useState(false);

//conditionaldiagnosis  
const handleInputMainPointCD = () => { 
  setShowMainPointCD(false);   
  {!ConditionalDiagnosis ? 
  (<>
    setShowMainPointCD(false);
    </>
  ):(
    <>
    setShowMainPointCD(true);
    </>
  )
}
setShowMainPointCD(true);
setConditionalDiagnosis(ConditionalDiagnosis);
};
const handleCancelClickMPointCD = () => {
setShowLoader(false);
setShowMainPointCD(false);
};
const handleInputChangeMPointCD = (e) => {
setConditionalDiagnosis(e.target.value);
};
const handleSaveClickMPointCD = () => {
setShowLoader(true);
setTimeout(() => { 
setIsEditingCD(false); 
handleSaveMPointCD();
}, 2000); 
};

const handleSaveMPointCD = async (event) => {   
// try {   
const data = { 
  admin_id: adminId,
  session_id : SessionIDCheck,   
  user_id: userid, 
  conditional_diagnosis: ConditionalDiagnosis , 
};  
try {
  await updateChatSession(SessionIDCheck, { conditional_diagnosis: ConditionalDiagnosis });
  toast.success('Conditional diagnosis updated successfully.', { position: toast.POSITION.TOP_RIGHT });
  setShowLoader(false);
  setShowMainPointCD(false);
  setBackReload(true);
} catch (error) {
  logger.error('Error:', error);
  toast.error('An unexpected error occurred.');
} finally {
  setLoading(false);
}


};

//  --------------------------------------------------

useEffect(() => {
  handleMyInsurance(UserId)
  const ageCal = moment().diff(userProfileData.dob, 'years'); 
  setAgeTxt(userProfileData.dob ? ageCal : '');   

  localStorage.setItem('UserId', JSON.stringify(UserId));
 
}, [UserId]);

const handleMyInsurance = async (UserIdNew) => {  
  try {
    const insuranceList = await getInsuranceData(UserIdNew);
    if (insuranceList && insuranceList.length > 0) {
      const insurance = insuranceList[0];
      localStorage.setItem('myinsuranceinfo', JSON.stringify(insurance));
      setMyinsuranceinfo(insurance);
      const currentDate = moment();
      const expiry = moment(insurance.expiry_date);
      setCheckExpiry(expiry.isBefore(currentDate, 'day'));
    }
  } catch (error) {
    logger.error('Error fetching insurance:', error);
  }
}; 
const [documents, setDocuments] = useState([]); // Document list state
const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state
const [selectedDocument, setSelectedDocument] = useState(null); // Track the selected document

// Open modal and set selected document
const openModal = (doc) => { 
  setSelectedDocument(doc);
  setIsModalOpen(true);
};

// Close modal and reset selected document
const closeModal = () => {
  setIsModalOpen(false);
  setSelectedDocument(null);
};

// Add document dynamically
const addDocument = (name, url) => {
  const newDocument = { name, url };
  setDocuments([...documents, newDocument]); // Add to the document list
};
const handleButtonClickFollowZoomMeet = () => {
  const zoomSchedulerUrl = selectedItemFollowup?.zoom_meeting?.patient_url; // Zoom Scheduler page URL
  if (!zoomSchedulerUrl) return;
  window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
};

const toggleDivZoomMeet = () => {
  setCheckZoomMeet(false);    
  setOpenDiv(openDiv === 'ZoomMeet' ? null : 'ZoomMeet');
};
const handleButtonClickZoomMeet = () => {
  const zoomSchedulerUrl = selectedZoomMeet?.patient_url; // Zoom Scheduler page URL
  if (!zoomSchedulerUrl) return;
  window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
};

const getToken = async () => {
  const response = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/getAssemblyAIToken');
  const data = await response.json();
  if (data.error || data.status === 'error') {
    return null;
  }
  return data.token;
};

const generateTranscript = async (targetTextArea) => {
  try {
    const token = await getToken();
    if (!token) return;
    setIsConnecting(true);
    socket.current = new WebSocket(`wss://api.assemblyai.com/v2/realtime/ws?sample_rate=16000&token=${token}`);

    const texts = {};
    socket.current.onmessage = (voicePrompt) => {
     // let msg = '';
      let msg = transcripts[targetTextArea] || ''; 
      const res = JSON.parse(voicePrompt.data);
      if (res.text && res.text.trim() !== '') {  // Check if res.text is not null or blank
        texts[res.audio_start] = res.text;
      }
      // texts[res.audio_start] = res.text;
      const keys = Object.keys(texts).filter(key => key !== 'undefined').sort((a, b) => a - b);
      keys.forEach((key) => {
        msg += ` ${texts[key]}`;
      });

      setTranscripts((prevState) => ({
        ...prevState,
        [targetTextArea]: msg.trim(), // || '',
      }));
    };

    socket.current.onerror = (event) => {
     // logger.error('WebSocket error:', event);
      socket.current.close();
      socket.current = null;
      setIsConnecting(false);
    };

    socket.current.onclose = (event) => { 
      socket.current = null;
      setIsConnecting(false);
    };

    socket.current.onopen = () => {
      setIsConnecting(false);
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          streamRef.current = stream;
          recorder.current = new RecordRTC(stream, {
            type: 'audio',
            mimeType: 'audio/webm;codecs=pcm',
            recorderType: RecordRTC.StereoAudioRecorder,
            timeSlice: 250,
            desiredSampRate: 16000,
            numberOfAudioChannels: 1,
            bufferSize: 4096,
            audioBitsPerSecond: 128000,
            ondataavailable: (blob) => {
              const reader = new FileReader();
              reader.onload = () => {
                const base64data = reader.result;
                if (socket.current) {
                  socket.current.send(JSON.stringify({ audio_data: base64data.split('base64,')[1] }));
                }
              };
              reader.readAsDataURL(blob);
            },
          });
          recorder.current.startRecording();
        })
        .catch((err) => logger.error('getUserMedia error:', err));
    };

    setIsRecording((prevState) => ({
      ...prevState,
      [targetTextArea]: true,
    }));

    setActiveMic(targetTextArea);
  } catch (error) {
    logger.error('Error generating transcript:', error);
  }
};

const endTranscription = (targetTextArea) => {
  if (socket.current) {
    socket.current.send(JSON.stringify({ terminate_session: true }));
    socket.current.close();
    socket.current = null;
  }

  if (recorder.current) {
    recorder.current.stopRecording();
    recorder.current = null;
  }
  if (streamRef.current) {
    streamRef.current.getTracks().forEach(track => track.stop());
    streamRef.current = null;
  }

  setIsRecording((prevState) => ({
    ...prevState,
    [targetTextArea]: false,
  }));

  setActiveMic(null);
};


const handleMicClick = (targetTextArea) => {
  if (isConnecting) { 
   // console.log('Connecting, please wait...');
    return;
  }
  if (activeMic === targetTextArea) {
    endTranscription(targetTextArea);
  } else {
    if (activeMic) {
      endTranscription(activeMic);
    }
    generateTranscript(targetTextArea);
  }
};

const handleTextChangeMedicalCondition = (e) => {   
  setTranscripts({ ...transcripts, medicalcondition: e.target.value });     
  const valueTxt =  e.target.value;
  setMedicalConditionsData(valueTxt);    
};
 
  const [statusMessage, setStatusMessage] = useState("");

  const handleFollowUpSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!activeOption || !transcripts.medicalcondition) {
      setStatusMessage("400 Bad Request: Missing required fields.");
      return;
    }

    const requestBody = {
      session_id:  SessionIDCheck,
      user_id: userid, // Pass the session ID 
      description: transcripts.medicalcondition, // Description from transcripts
      title: activeOption,   // Title from the active option
    };

    setLoading(true);
    setStatusMessage(""); // Reset status message

    try {
      const docRef = await addDoc(collection(db, 'followup_requests'), {
        ...requestBody,
        status: 'active',
        created_at: new Date().toISOString(),
      });
      const savedData = { id: docRef.id, ...requestBody };
      setStatusMessage("200 OK: Followup request created successfully.");
      setSelectedItemFollowup(savedData);
      setCheckFollowupMeet(true);
      setOpenDiv(null);
      setErrors({});
      setLoading(false);
      setShowLoader(false);
    } catch (error) {
      logger.error('Error creating followup request:', error);
      setStatusMessage("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };


  const calculateDuration = (startTs, endTs) => { 
    const durationInSeconds = endTs - startTs;
    const durationInMinutes = Math.floor(durationInSeconds / 60);
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
  
    const hourString = hours > 0 ? `${hours} hour` : "";
    const minuteString = minutes > 0 ? `${minutes} minute` : "";
  
    return [hourString, minuteString].filter(Boolean).join(" and ");
  };




  return (
    <div>
      <div className='container-fluid p-0'>
        <Header />
        <div className='container-fluid p-0 contentBody PatientDashboardMain w-100'>
        {ShowLoaderPage && <LoaderSpinner />} 
        <div className="sideBarInfoDiv"> 
                       
                        <div className="titleDivRight">
                          
                          
                            <ul className="userInfoDetails">
                              <li  className="imgBox">
                                 <b> 
                                  {getInitials(fullName)}  
                                </b>  
                              </li>
                            <li>
                            <h2 className="capitalizeTxt">{fullName}</h2>
                              </li>
                            <li>
                              <span style={{display:"flex", justifyContent:'center',alignItems:'center'}}>
                                <img src={Icons[0].admin_mailIcon}  />
                                <label className="singleLineEllipsis">{email}</label>
                                </span>
                              </li>
                              
                              <li>
                                <img src={Icons[0].admin_phoneIcon} />
                                <label>{phoneNumber}</label>
                              </li>

                              <li className="dateNgenderTxt">
                              <span style={{display:"flex", justifyContent:'space-between'}} className="w-100">
                                <b className={GenderTxt ? '' : 'd-none'}>
                                <img src={Icons[0].admin_userIcon} />
                                <label className="capitalizeTxt">{GenderTxt}</label>
                              </b>
                              <b className={DOBTxt ? '' : 'd-none'}>
                                <img src={Icons[0].admin_calendarIcon} />
                                <label>{moment(DOBTxt).format('MMM DD, YYYY')}{' '}({ageCal} years)</label>
                                </b>
                                </span>
                              </li>
                            </ul>
                            <div className="listOptDiv">
                            <ul className={"userMedicalInfo " 
                              // + (CheckExpiry && ' dateExpiryTxt')
                              }>
                              {/* {CheckExpiry &&
                                <h3> <img src={Icons[0].errorImg} style={{width:'24px', marginRight:'5px'}} /> Health card has expired </h3>
                              } */}
                              <li> 
                                <b>{myinsuranceinfo.group_name}</b>
                                <label>Group name</label>
                              </li>
                              <li className="float-right"> 
                              <b>{myinsuranceinfo.policy_id}</b>                              
                                <label>Insurance ID</label>
                              </li> 
                              <li>
                              <b>{myinsuranceinfo.insurance_carrier}</b>
                                <label>Insurance Carrier</label>
                              </li>
                              <li>
                                <b>{WeightTxt ? WeightTxt : '0'}{' '}<span>lbs</span></b>
                                <label>Weight</label>
                              </li>
                              <li>
                                <b>{HeightTxt ? HeightTxt : '0'}{' '}<span>cm</span></b>
                                <label>Height</label>
                              </li>
                            </ul>
                             <ul className="OptionDivInfo">
                              <li className="w-100">
                              <button onClick={newappointmentLink} className={'w-100 ' 
                                // +(CheckExpiry && ' dateExpiryBtn')
                                }> 
                              <img src={Icons[0].addIcon}  />
                                  Click here to start
                                  </button>
                              </li>
                              {/* <li>
                                <b className="text-center">{UserHistoryNumber}</b>
                                <label>Appointments</label>
                              </li> */}
                            </ul>  
                            </div>
                        </div>  
        </div>
         
        <div className="appointmenttable ">
 
      <div className='container-fluid p-0 adminDashboardMain '>
           

              <div className="contentInnerBody">
               
                
                <div className="contentMainBox viewPatientMain"> 
                  

                   

                     <div className={"patientSummaryMain " +(!showSummay ? 'd-none':'')}>
                      
                 
    <div className="innerDivRecords " >
 
		<nav>
			<div className="nav nav-tabs mb-0" id="nav-tab" role="tablist">
				<button className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
            onClick={() => handleTabClick(0)} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Initial AI Interview</button>
				{/* <button className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => handleTabClick(1)} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Plan of Care</button> */}
				<button className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
            onClick={() => handleShowChat(2)} id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Presenting Symptoms</button>
			  <button className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
            onClick={() => handleShowChat(3)} id="nav-reportData-tab" data-bs-toggle="tab" data-bs-target="#nav-reportData" type="button" role="tab" aria-controls="nav-reportData" aria-selected="false">Reports</button>
        {selectedZoomMeet?.meeting_status === 'completed' && isFinalNoteSubmitted && (
          <button className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
            onClick={() => handleTabClick(4)} id="nav-zoom-tab" data-bs-toggle="tab" data-bs-target="#nav-zoom" type="button" role="tab" aria-controls="nav-zoom" aria-selected="false">Telehealth Consultation</button>
        )}
        {finalConsultantNote && isFinalNoteSubmitted && zoomSummaryData && (
          <button className={`nav-link ${activeTab === 5 ? 'active' : ''}`}
            onClick={() => handleTabClick(5)} id="nav-finalnote-tab" data-bs-toggle="tab" data-bs-target="#nav-finalnote" type="button" role="tab" aria-controls="nav-finalnote" aria-selected="false">Final Consultant Note</button>
        )}
			</div>
      <button className="backBtn" onClick={handleBackButton}                        
                            ><img src={Icons[0].admin_backBtn} />Back</button>
		</nav>
		<div className="whiteBg tab-content p-3 bg-white" id="nav-tabContent" >
			<div className={`tab-pane fade ${activeTab === 0 ? 'active show' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div className="despInfoDiv  position-relative  d-flex" style={{height: '70px'}}>
          <h2>Initial AI Interview</h2>
          <div  className="headDespInfoDiv position-absolute top-0 end-0 ">
            {/* <ul className="infoDivPatientList" >
            <li>
              <label>Consultation Date</label>
              <b>{formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
            </li>
            <li>
              <label>Illnesses</label>
              <b>{RecordData.illness}</b>
            </li>
          </ul> */}
          <ul className="optionUpdateList" style={{width:'auto'}}>
        
        
      
              <li className={selectedItem ? '' : 'd-none'}>
                <label>Patient Status</label>
                    <button className={"selectedItemBtn color" + (['shared_with_pcp','in_review','under_review','approved','needs_signature'].includes(selectedItem) ? 'pending' : (selectedItem || 'pending'))} >
                        {['shared_with_pcp','in_review','under_review','approved','needs_signature'].includes(selectedItem) ? 'Pending' : (selectedItem ? selectedItem.replace(/_/g,' ') : '')}
                    </button>
                </li>  
                {selectedZoomMeet?.meeting_status  !== 'deactive' && (
                <>
                <li className={"text-left "+(selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? '' :'d-none')}>
                <label>Patient Meeting</label>    
                {(!selectedZoomMeet?.meeting_status || selectedZoomMeet?.meeting_status === 'active') ? (
                            <button className="blueBtnStyle"
                            onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet} 
                            disabled={selectedItem?.toLowerCase() === "completed"}
                            >
                              Meeting Details 
                            </button>
                          ) : (
                            <button className="blueBtnStyle" disabled>
                              Meeting Ended
                            </button>
                          )}
                          
               
                      {/* <button className="blueBtnStyle" onClick={toggleDivZoomMeet}>
                        Meeting Details 
                      </button> */}

          {openDiv === 'ZoomMeet' && (
             <div  className="patientStatusBox ZoomMeetMain"  style={{zIndex: '11'}}> 
              {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                    <>
                    <div className="p-2">
                     <h2 className="mb-2">Meeting Details</h2>
                     <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting ID</label>
                         <b>{selectedZoomMeet?.meeting_id || '-'}</b>                      
                      </div> 
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting Title</label>
                         <b>{selectedZoomMeet?.topic || '-'}</b>                      
                      </div> 
                      
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Date Time</label>
                         <b>{selectedZoomMeet?.start_ts ? moment.unix(selectedZoomMeet.start_ts).format("MMM DD, YYYY - h:mm A") : '-'}</b>                      
                      </div>
                   
                      <div className="meetingDetailsTxt">                    
                        <button onClick={handleButtonClickZoomMeet}>Join Meeting</button>                     
                      </div> 
                      </div>
                      
                    </> ):('')}
                    </div>
                  )}
                   
                </li>
                </> )}
                {(selectedZoomMeet?.meeting_status === 'deactive' || followupZoomMeet || checkFollowupMeet) && (<>
                <li style={{width:"130px"}}
        >
            <label className={followupZoomMeet}>Follow-up</label> 
  <button
  className={"selectedItemBtn " + (followupZoomMeet ? (followupMeetingDone ? 'greenBtnStyle' : 'blueBtnStyle newBlueBtn') : 'newClickBtn')}
  onClick={toggleDivFollowup}
  style={{ width: followupZoomMeet ? "120px" : "110px", padding: "5px", ...(followupMeetingDone ? { background: '#28a745', borderColor: '#28a745' } : {}) }}
>
  {
    followupZoomMeet
    ? (followupMeetingDone ? "Completed" : "Meeting Active")
    : checkFollowupMeet
    ? "Request Sent"
    : "Add Followup"}
</button>

      {openDiv === 'Followup' && (
 <div className="patientStatusBox datePickerDiv followupSetMain  ZoomMeetMain" style={{ border: '1px solid #ccc', marginTop: '10px', padding: '10px', zIndex: '11'}}>
         
         {selectedItemFollowup && Object.keys(selectedItemFollowup).length > 0 ? (<>
           
          <h2 style={{fontSize:'16px'}}  className="mb-2">Follow up Details </h2>
                  
                                     
                      {followupZoomMeet ? (
                            <>
                              <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting ID</label>
                         <b>{selectedItemFollowup?.zoom_meeting?.meeting_id || '-'}</b>                      
                      </div> 
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting Title</label>
                         <b>{selectedItemFollowup?.zoom_meeting?.topic || '-'}</b>                      
                      </div> 
                      
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Date Time</label>
                         <b>{selectedItemFollowup?.zoom_meeting?.start_ts ? moment.unix(selectedItemFollowup.zoom_meeting.start_ts).format("MMM DD, YYYY - h:mm A") : '-'}</b>                      
                      </div>
                      <div className="meetingDetailsTxt">
                              {followupMeetingDone ? (
                                <span style={{ color: '#28a745', fontWeight: '600', fontSize: '13px' }}>Meeting Completed</span>
                              ) : (
                                <button onClick={handleButtonClickFollowZoomMeet}>Join Meeting</button>
                              )}
                              </div>  
                              
                            </>
                          ) : (
                            <>
                              <div className="meetingDetailsTxt">
                         <label className="labelTxt">Title</label>
                         <b>{selectedItemFollowup.title}</b>                      
                      </div>                          
                       
                         <div className="meetingDetailsTxt align-items-start"> 
                          <label className="labelTxt">Description: </label>
                          <b className="twoLineEllipsis" title={selectedItemFollowup.description} >{selectedItemFollowup.description}</b> 
                          </div>
                            <div className="meetingDetailsTxt">  
                              <button className="newBtn cancelBtn" disabled={true}  >Request in Progress</button>  
                              </div>                  
                            </>
                          )}  
                    
        
                      

         </>):(<>
          <form>
            
            <div>
              <h3 style={{fontSize:'16px'}}  className="mb-2">Follow-Up: Choose any one</h3>
              <ul className="followupOptList">          
              {options.map((option, index) => (
                  <li
                    key={index}
                    className={activeOption === option ? 'active' : ''} // Apply "active" class to the selected item
                    onClick={() => handleOptionClick(option)} // Handle click event
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
            <h3 style={{fontSize:'16px'}} className="mb-0">Follow-up Description</h3>
           <div className="mt3 inputDiv fillDetailsForm newFillDetailForm d-flex">
                <textarea  
                    className="textareaFollowup"  
                    value={transcripts.medicalcondition}
                    onChange={handleTextChangeMedicalCondition} 
                    placeholder={activeMic === 'medicalcondition' ? 'Mic On ' : ""} > 
                </textarea>
            <span className="attachmentSpan">
              <a onClick={() => handleMicClick('medicalcondition')}  
              disabled={isConnecting || activeMic === 'connecting'} 
              className={ (activeMic === 'medicalcondition' ? 'deactiveBtnClass' : 'activeBtnClass')}> 
                  <img src={Icons[0].micIcon}  className= "logoImg "   alt="" />
              </a> 
            </span> 
            </div> 

            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button className="newBtn cancelBtn" onClick={handleCancelFollowup}>
                Cancel
              </button> 
              <button 
                     onClick={handleFollowUpSubmit}
                      className="newBtn"
                      type="submit"
                      disabled={loading}
                      style={{
                        cursor: loading ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {loading ? 'Saving...' : 'Save'}
             </button>
            </div>
         
        </form>
         </>)
 
         }
       
        </div>
      
                  )}


                </li>
                </>)}
        </ul>
        </div>

        </div>
        <div className="innerDivBoxPC">
        {FollowupData?.length > 0 ? (
          FollowupData.map((item, index) =>
            item && item.followup_summary ? (
              <div key={index}>
                <div className="despInfoDiv" style={{borderBottom:'1px solid #ddd', marginBottom:'10px', paddingBottom:'6px'}}>
                <div className="headDespInfoDiv">
                  <ul className="infoDivPatientList">
                    <li>
                      <label>Consultation Date</label>
                      <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                    </li>
                    <li>
                      <label>Follow up</label>
                      <b>{item.title}</b>
                    </li>
                    {
                      calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)
                        ? <li>
                          <label>Duration:</label>
                          <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                          </li>
                        : null
                    }
                      <li>
                         <label>Location</label>
                          <b>Home</b>
                      </li>
                  </ul>
                </div>
              </div>
              <pre>{item.followup_summary}</pre>
              <hr className="my-4"></hr>
              </div>
            ) : null
          )
        ) : null}
          <div className="despInfoDiv" style={{borderBottom:'1px solid #ddd', marginBottom:'10px', paddingBottom:'6px'}}>
            <div className="headDespInfoDiv">
              <ul className="infoDivPatientList">
                <li>
                  <label>Consultation Date</label>
                  <b>{formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
                </li>
                <li>
                  <label>Illnesses</label>
                  <b>{RecordData?.illness || '-'}</b>
                </li>
                {(selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0) ?
                        (<>
                          <li>
                          <label>Duration:</label>{" "}
                          <b>{calculateDuration(selectedZoomMeet?.start_ts, selectedZoomMeet?.end_ts)}  </b>
                          </li>
                          <li>
                              <label>Location</label>
                              <b>Home</b>
                          </li>
                        </>
                        ): null }
              </ul>
            </div>
          </div>
          {EmergencyQuest ? (
            <p className="urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p>
          ) : !isFinalNoteSubmitted ? (
            <div style={{textAlign:'center', padding:'20px'}}>
              <p style={{color:'#888', fontStyle:'italic'}}>Your clinical summary will be available once your care team has completed the consultation and finalized your report.</p>
            </div>
          ) : summaryAIChatbot ? (
            <div>
              {renderAISummary(summaryAIChatbot)}
            </div>
          ) : (
            <div style={{textAlign:'center', padding:'20px'}}>
              {isGeneratingSummary ? (
                <>
                  <div className="spinner-border text-primary" role="status" style={{width:'20px', height:'20px', margin:'8px auto'}}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p style={{color:'#666', marginTop:'8px', fontSize:'13px'}}>Generating your clinical summary...</p>
                </>
              ) : (
                <p style={{color:'#888', fontStyle:'italic'}}>Your clinical summary is being prepared by your care team. Please check back shortly.</p>
              )}
            </div>
          )}
        </div>
          
			</div>
			<div className={`tab-pane fade ${activeTab === 1 ? 'active show' : ''}`} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
      <div className="d-flex gap-4">
               <div className="despInfoDiv PlanCareTab w-50">
          <h2>Plan of Care</h2>
        
         
          {!showMainPoint ? (
                  <>     
                   {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : PlanOnCareData ? <pre className="innerDivBoxPC">{PlanOnCareData}</pre> : 'No Plan On Care' }  
                   {!EmergencyQuest && (
                        <>
                          {PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name ? (
                            <>
                              <b>Primary Care Physician (PCP): </b>
                              {[
                                PCP_Pharmacy.pcp.name,
                                PCP_Pharmacy.pcp.address,
                                PCP_Pharmacy.pcp.phone ? `Phone: ${PCP_Pharmacy.pcp.phone}` : null,
                                PCP_Pharmacy.pcp.fax ? `Fax: ${PCP_Pharmacy.pcp.fax}` : null,
                              ].filter(Boolean).join(', ')}
                              <br />
                            </>
                          ) : null}

                          {PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name ? (
                            <>
                              <b>Pharmacy information: </b>
                              {[
                                PCP_Pharmacy.pharmacy.name,
                                PCP_Pharmacy.pharmacy.address,
                                PCP_Pharmacy.pharmacy.phone ? `Phone: ${PCP_Pharmacy.pharmacy.phone}` : null,
                                PCP_Pharmacy.pharmacy.fax ? `Fax: ${PCP_Pharmacy.pharmacy.fax}` : null,
                              ].filter(Boolean).join(', ')}
                            </>
                          ) : null}
                        </>
                      )} 
                 </>
              ) :(
                <div className='textareaSummary innerDivBox w-100'>
                  <textarea value={PlanOnCareData} onChange={handleInputChangeMPoint} style={{    height: '80%', width:' 100%'}} /> 
                  <hr></hr>
                 <div className='editSaveOpt' >
                    {ShowLoader ? (<>
                      <button  > Loading
                      <div className="spinner-border text-light" role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSaveClickMPoint}>  
                    Save Changes
                    </button>
                    </>)

                    }
                    
                    <button onClick={handleCancelClickMPoint}>Cancel</button>
                  </div>
                </div> 

              )}
               </div>
                <div className="despInfoDiv PlanCareTab w-50  ">
          <h2>Conditional Diagnosis</h2>
          {!showMainPointCD ? (
                  <>     
                   {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : ConditionalDiagnosis ? <pre className="innerDivBoxPC">{ConditionalDiagnosis}</pre> : 'No Conditional Diagnosis' }  
                 </>
              ) :(
                <div className='textareaSummary innerDivBox w-100'>
                  <textarea value={ConditionalDiagnosis} onChange={handleInputChangeMPointCD} style={{    height: '80%', width:' 100%'}} /> 
                  <hr></hr>
                 <div className='editSaveOpt' >
                    {ShowLoader ? (<>
                      <button  > Loading
                      <div className="spinner-border text-light" role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSaveClickMPointCD}>  
                    Save Changes
                    </button>
                    </>)

                    }
                    
                    <button onClick={handleCancelClickMPointCD}>Cancel</button>
                  </div>
                </div> 

              )}
               </div> 

      </div>
      </div>
			<div className={`tab-pane fade ${activeTab === 2 ? 'active show' : ''}`} id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
      <div className="despInfoDiv">
          <h2>Presenting Symptoms</h2>
          </div>
        <div className="chatbotConversation  pb-0">
      <div className="messageListBox mb-0">
      {answerLoader ? ( 
                    <>
                    <div className= "quesListDiv " >
                        <div className={"chatbot aiQuest "}>
                            <span className="imgBox">
                              <img src={Icons[0].chatbot} alt="Chatbot" />
                            </span>
                            <span> 
                                <div className="showLoaderDot">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div> 
                            </span>
                          </div>
                    </div>
                    </>):(<>
                    
                      <div className="chatbot">
                <span className="imgBox">
                  <img src={Icons[0].chatbot} alt="Chatbot" />
                </span>
                <span>
                  <b className="AI_dateTime">
                    AI 
                  </b> 
                      <label className="quesTxt">Hi, How may I help you today? You may select or type a symptom you’re facing currently.</label>
                      <div className="questOpt">
                        <b>Please select any</b>
                        <ul className={!selectedIllness ? 'illnessesListOpt' : 'illnessesListOpt selected'}>
                          {illnessesList?.map((item, index) => (
                            <li
                              key={index}
                              className={selectedIllness === item ? 'active' : 'disabled'} 
                              style={{ pointerEvents: selectedIllness && selectedIllness !== item ? 'none' : 'auto' }}
                            >
                              <b>{item}</b>
                            </li>
                          ))}
                        </ul>
                      </div>
                     
                </span>
              </div>

           {ChatHistory.length > 0 && (
                <div className="quesListDiv">
                  {ChatHistory.map((q, index) => (
                    <div key={index}>
                      <div className="chatbot aiQuest">
                        <span className="imgBox">
                          <img src={Icons[0].chatbot} alt="Chatbot" />
                        </span>
                        <span> 
                              <b className="AI_dateTime">
                                AI 
                              </b>
                              <label className="quesTxt">{q.question}</label>
                             
                        </span>
                      </div>
                      {q.answer && (
                        <div className="chatbot userReply">
                          <span className="imgBox">
                            <b>{getInitials(fullName)}</b>
                          
                          </span>
                          <span>
                            <b className="AI_dateTime">
                              YOU 
                            </b>
                            <label className="quesTxt">{q.answer}</label>
                          </span>
                        </div>
                      )} 
                    </div>
                  ))}
                </div>
              )} 
                    
                    </>)}
              

            </div> 
     </div>
		 
			</div>
      <div className={`tab-pane fade ${activeTab === 3 ? 'active show' : ''}`} id="nav-reportData" role="tabpanel" aria-labelledby="nav-reportData-tab">
      <div className="despInfoDiv">
          <h2>Reports </h2>
          </div>
          <div className="innerDivBoxPC"> 
           
        
<ol className="reportListOptLink">
  {sortedGroupedDocuments.length > 0 ? (
    sortedGroupedDocuments
      .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
      .map(({ doc_type, documents, Name  }) => (
        <li key={doc_type}>
       
          {documents.map((doc, index) => (
            <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                 <b style={{ textTransform: "capitalize", textDecoration: "none" }} className={ doc_type === "other_report"  && index !== 0 && 'd-none'}>
                 {Name} 
                 {/* {doc_type.replace('_', ' ')} */}
                 </b>
              {/* Document URL with conditional button */}
              {doc.doc_url && (
                <span
                  className={
                    "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                  }
                >
                  <button
                    className="pdfButton pdfViewBtn"
                    onClick={() => openModal(doc?.doc_url)}
                  >
                    View{" "}
                    <img
                      src={Icons[0].viewPDF}
                      alt="PDF Icon"
                      style={{ width: "24px", marginLeft: "10px" }}
                    />
                  </button>
                </span>
              )}

              {/* Document Text */}
              {doc.doc_text && <p>{doc.doc_text}</p>}
              {/* PCP / Pharmacy — show doc_summary directly */}
              {(doc_type === "pcp" || doc_type === "pharmacy") && doc.doc_summary && (
                <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_summary}</p>
              )}
              {/* Document Summary — only for other_report (uploaded PDFs) */}
              {doc_type === "other_report" && doc.doc_summary && doc.doc_summary !== "None" && (
                <>
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 style={{ fontSize: "16px", marginTop: "14px", fontWeight: "600" }} className="my-0">
                      {index + 1}. Other Report Summary
                    </h3>
                    {doc.doc_url && (
                      <span className="pdfButtonModal">
                        <button className="pdfButton pdfViewBtn" onClick={() => openModal(doc?.doc_url)}>
                          View{" "}
                          <img src={Icons[0].viewPDF} alt="PDF Icon" style={{ width: "24px", marginLeft: "10px" }} />
                        </button>
                      </span>
                    )}
                  </div>
                  <pre style={{ margin: "5px 0", textTransform: "capitalize" }}>{doc.doc_summary}</pre>
                </>
              )}

              {/* Conditional Divider */}
              {doc.doc_url && (
                <hr className={doc_type !== "other_report" ? " d-none" : ""} />
              )}
            </div>
          ))}
        </li>
      ))
  ) : (
    <p style={{ textAlign: "center" }}>No reports found</p>
  )}
</ol>

          </div>

          </div>

      {/* Tab 4 — Telehealth Consultation */}
      <div className={`tab-pane fade ${activeTab === 4 ? 'active show' : ''}`} id="nav-zoom" role="tabpanel" aria-labelledby="nav-zoom-tab">
        <div className="despInfoDiv">
          <h2>Telehealth Consultation</h2>
        </div>
        <div className="innerDivBoxPC h-auto">
          {(zoomSummaryData || zoomHPI) ? (
            <div>
              {zoomHPI ? (
                <>
                  <div style={{ marginBottom: '16px' }}>
                    <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>History of Present Illness (HPI)</h3>
                    <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomHPI)}</div>
                  </div>
                  {(() => { const val = zoomPMH || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'PAST MEDICAL AND SURGICAL HISTORY', 'PAST MEDICAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Past Medical History (PMH)</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                  {(() => { const val = zoomMedications || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'CURRENT MEDICATIONS', 'MEDICATIONS'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Medications</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                  {(() => { const val = zoomAllergies || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'ALLERGIES'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Allergies</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                  {(() => { const val = zoomSocialHistory || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'SOCIAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Social History</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                  {(() => { const val = extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'FAMILY HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Family History</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                  {zoomROS && (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Review of Systems</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomROS)}</div>
                    </div>
                  )}
                  {zoomDiagnosisData && (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomDiagnosisData)}</div>
                    </div>
                  )}
                  {zoomPlanData && (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomPlanData)}</div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div style={{ fontSize: '14px', lineHeight: '1.7', marginBottom: '16px' }}>{renderAISummary(zoomSummaryData)}</div>
                  {zoomDiagnosisData && (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomDiagnosisData)}</div>
                    </div>
                  )}
                  {zoomPlanData && (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomPlanData)}</div>
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#888' }}>
              <p style={{ fontSize: '15px', marginBottom: '8px' }}>AI summary is being processed.</p>
              <p style={{ fontSize: '13px' }}>Please check back shortly after the recording is ready.</p>
            </div>
          )}
        </div>
      </div>

      {/* Tab 5: Final Consultant Note (read-only for patient) */}
      <div className={`tab-pane fade ${activeTab === 5 ? 'active show' : ''}`} id="nav-finalnote" role="tabpanel" aria-labelledby="nav-finalnote-tab">
        <div className="despInfoDiv position-relative d-flex" style={{ height: '50px', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>Final Consultant Note</h2>
          {(finalConsultantNote || finalConsultantHPI) && (
            <div className="position-absolute top-0 end-0" style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
              <a onClick={!isGeneratingPdf ? downloadFinalNotePdf : undefined} style={{ cursor: isGeneratingPdf ? 'not-allowed' : 'pointer', width: 'auto', padding: '0 10px', opacity: isGeneratingPdf ? 0.6 : 1 }} className="editBtnNewSummary">
                {isGeneratingPdf ? 'Generating...' : 'Download PDF'}
              </a>
            </div>
          )}
        </div>

        {/* Report version history dropdown — patient sees only admin-submitted versions */}
        {patientReportHistory.length > 1 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '8px 0 12px 0', padding: '8px 14px', background: '#f0f4f8', borderRadius: '6px', border: '1px solid #d0d7e2', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '12px', color: '#4a6fa5', fontWeight: '700', whiteSpace: 'nowrap' }}>Report Version:</span>
            <select
              value={selectedPatientReportVersion || ''}
              onChange={(e) => handleViewPatientReportVersion(e.target.value || null)}
              style={{ flex: 1, minWidth: '220px', maxWidth: '420px', fontSize: '12px', padding: '5px 8px', borderRadius: '4px', border: '1px solid #b0c0d8', background: '#fff', cursor: 'pointer' }}
            >
              <option value="">Latest Submitted</option>
              {patientReportHistory.map(h => (
                <option key={h.version} value={h.version}>
                  V{h.version} — {h.report_type === 'initial' ? 'Initial Report' : `Followup: ${h.followup_topic || 'Consultation'}`}
                  {(h.submitted_at || h.final_consultant_generated_at) ? ` · ${new Date(h.submitted_at || h.final_consultant_generated_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}` : ''}
                </option>
              ))}
            </select>
            <span style={{ fontSize: '11px', color: '#888' }}>({patientReportHistory.length} versions)</span>
            {selectedPatientReportVersion && (
              <a onClick={() => handleViewPatientReportVersion(null)} style={{ cursor: 'pointer', fontSize: '12px', color: '#024C9C', fontWeight: '600', textDecoration: 'underline', whiteSpace: 'nowrap', marginLeft: 'auto' }}>
                Back to Latest
              </a>
            )}
          </div>
        )}

        <div className="innerDivBoxPC">
          {(finalConsultantNote || finalConsultantHPI) ? (
            <div>
              <div ref={finalNoteContentRef}>

                {/* ── Issue 4: PCP / Pharmacy Header Block ── */}
                {(PCP_Pharmacy?.pcp?.name || PCP_Pharmacy?.pharmacy?.name) && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', marginBottom: '16px', overflow: 'hidden', fontSize: '12px' }}>
                    <div style={{ padding: '12px 14px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f4f8' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Primary Care Physician</div>
                      {PCP_Pharmacy?.pcp?.name
                        ? <><div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pcp.name}</div>{PCP_Pharmacy.pcp.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pcp.address}</div> : null}{PCP_Pharmacy.pcp.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pcp.phone}</div> : null}{PCP_Pharmacy.pcp.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pcp.fax}</div> : null}</>
                        : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>}
                    </div>
                    <div style={{ padding: '12px 14px', backgroundColor: '#f8f9fa' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Pharmacy</div>
                      {PCP_Pharmacy?.pharmacy?.name
                        ? <><div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pharmacy.name}</div>{PCP_Pharmacy.pharmacy.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pharmacy.address}</div> : null}{PCP_Pharmacy.pharmacy.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pharmacy.phone}</div> : null}{PCP_Pharmacy.pharmacy.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pharmacy.fax}</div> : null}</>
                        : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>}
                    </div>
                  </div>
                )}

                {/* ── Patient Demographics ── */}
                {(fullName || DOBTxt || GenderTxt || phoneNumber) && (
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{ fontWeight: '700', fontSize: '18px', color: '#024C9C', marginBottom: '8px', textTransform: 'capitalize' }}>{fullName}</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'hidden', fontSize: '12px' }}>
                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Date of Birth</div>
                        <div style={{ fontWeight: '600', color: '#222' }}>{DOBTxt ? moment(DOBTxt).format('MMM DD, YYYY') : '—'}</div>
                      </div>
                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Age</div>
                        <div style={{ fontWeight: '600', color: '#222' }}>{ageCal ? `${ageCal} yrs` : '—'}</div>
                      </div>
                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Sex</div>
                        <div style={{ fontWeight: '600', color: '#222', textTransform: 'capitalize' }}>{GenderTxt || '—'}</div>
                      </div>
                      <div style={{ padding: '10px 12px', backgroundColor: '#f8f9fa' }}>
                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Phone</div>
                        <div style={{ fontWeight: '600', color: '#222' }}>{phoneNumber || '—'}</div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ── Issue 5: Chief Complaint ── */}
                {(() => {
                  let complaint = selectedIllness || RecordData?.illness || '';
                  if (!complaint) {
                    const hpi = finalConsultantHPI || zoomHPI || '';
                    const m = hpi.match(/presents?\s+with\s+([^.,]+)/i);
                    if (m) complaint = m[1].trim();
                    else if (hpi) complaint = hpi.split(/[.!?]/)[0].trim().slice(0, 150);
                  }
                  return complaint ? (
                    <div style={{ marginBottom: '16px', padding: '10px 14px', backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: '6px' }}>
                      <div style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#b8860b', marginBottom: '4px', letterSpacing: '0.5px' }}>Chief Complaint</div>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>{complaint}</div>
                    </div>
                  ) : null;
                })()}

                {/* ── Issue 7: Insurance Information ── */}
                {(myinsuranceinfo?.insurance_carrier || myinsuranceinfo?.group_name || myinsuranceinfo?.policy_id || myinsuranceinfo?.expiry_date) && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', marginBottom: '16px', overflow: 'hidden', fontSize: '12px' }}>
                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Insurance Carrier</div>
                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.insurance_carrier || '-'}</div>
                    </div>
                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Group Name</div>
                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.group_name || '-'}</div>
                    </div>
                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Insurance ID</div>
                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.policy_id || '-'}</div>
                    </div>
                    <div style={{ padding: '10px 12px', backgroundColor: '#f0f7ff' }}>
                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Effective Date</div>
                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.expiry_date || '-'}</div>
                    </div>
                  </div>
                )}

                {finalConsultantHPI ? (
                  <>
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>History of Present Illness (HPI)</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantHPI)}</div>
                    </div>
                    {(() => { const val = finalConsultantPMH || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'PAST MEDICAL AND SURGICAL HISTORY', 'PAST MEDICAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Past Medical History (PMH)</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                    {(() => { const val = finalConsultantMedications || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'CURRENT MEDICATIONS', 'MEDICATIONS'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Medications</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                    {(() => { const val = finalConsultantAllergies || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'ALLERGIES'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Allergies</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                    {(() => { const val = finalConsultantSocialHistory || extractChatbotSection(zoomSummaryData || summaryAIChatbot, 'SOCIAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Social History</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                    {finalConsultantROS && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Review of Systems</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantROS)}</div>
                      </div>
                    )}
                    {finalConsultantNote && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {finalConsultantNote && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                      </div>
                    )}
                  </>
                )}
                {finalConsultantPlan && (() => {
                  const investigationFileNames = ['Basic Gastro Labs', 'Anemia Labs', 'Heaptic Labs', 'Stool Studies', 'Abdominal CT', 'Abdominal US', 'Barium Studies', 'EGD Order', 'Colon Order', 'Colonoscopy', 'Upper GI Endoscopy', 'Procedural Sedation'];
                  const recommendationFileNames = ['Colon Screening Guidelines', 'Telehealth Disclaimer', 'Weight Reducing Diet', 'High Fiber Diet', 'GERD and Lifestyle', 'Stress Management', 'FattyLiver', 'Fatty Liver', 'Diverticulosis', 'Irritable Bowel Syndrome', 'Inflammatory Bowel Disease'];
                  const investigationDocs = selectedFinalNoteFiles.filter(f => investigationFileNames.includes(f.fileName));
                  const recommendationDocs = selectedFinalNoteFiles.filter(f => recommendationFileNames.includes(f.fileName));

                  const planLines = finalConsultantPlan.split('\n');
                  let currentSection = '';
                  let investigationLines = [];
                  let recommendationLines = [];
                  let otherLines = [];

                  planLines.forEach(line => {
                    const trimmed = line.trim();
                    if (/^INVESTIGATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*INVESTIGATIONS\s*:/i.test(trimmed)) { currentSection = 'investigation'; return; }
                    if (/^THERAPIES\s*:/i.test(trimmed) || /^\d+[\.\)]\s*THERAPIES\s*:/i.test(trimmed)) { currentSection = 'recommendation'; return; }
                    if (/^RECOMMENDATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*RECOMMENDATIONS\s*:/i.test(trimmed)) { currentSection = 'recommendation'; return; }
                    if (!trimmed) return;
                    if (currentSection === 'investigation') investigationLines.push(line);
                    else if (currentSection === 'recommendation') recommendationLines.push(line);
                    else otherLines.push(line);
                  });

                  const renderDocGrid = (docs) => (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', marginTop: '8px' }}>
                      {docs.map((file) => (
                        <div key={file.id} style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          background: '#f8fafd', padding: '5px 10px',
                          borderRadius: '5px', border: '1px solid #e2e8f0',
                        }}>
                          <span style={{ fontSize: '12px', fontWeight: '500', color: '#013c7d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.fileName}</span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, marginLeft: '8px' }}>
                            <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#024C9C', fontWeight: '600', textDecoration: 'none', cursor: 'pointer' }}>View</a>
                            <a href={file.url} download={file.fileName + '.pdf'} style={{ fontSize: '11px', color: '#024C9C', fontWeight: '600', textDecoration: 'none', cursor: 'pointer' }}>Download</a>
                          </div>
                        </div>
                      ))}
                    </div>
                  );

                  return (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                      {otherLines.length > 0 && (
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(otherLines.join('\n'))}</div>
                      )}
                      {(investigationLines.length > 0 || investigationDocs.length > 0 || doctorRecommendations.length > 0) && (
                        <div style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('INVESTIGATIONS:\n' + investigationLines.concat(doctorRecommendations.map(r => '• ' + r)).join('\n'))}</div>
                          {investigationDocs.length > 0 && renderDocGrid(investigationDocs)}
                        </div>
                      )}
                      {(recommendationLines.length > 0 || recommendationDocs.length > 0) && (
                        <div style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('RECOMMENDATIONS:\n' + recommendationLines.join('\n'))}</div>
                          {recommendationDocs.length > 0 && renderDocGrid(recommendationDocs)}
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* ── Physician Signature Block ── */}
                {isFinalNoteSubmitted && (
                  <div style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #dee2e6' }}>
                    <div style={{ display: 'inline-block', minWidth: '220px' }}>
                      <div style={{ fontSize: '13px', color: '#555', marginBottom: '6px' }}>Electronically Reviewed &amp; Signed</div>
                      {submittedBySignature && (
                        <div style={{ marginBottom: '6px' }}>
                          <img src={submittedBySignature} alt="Physician Signature" style={{ maxHeight: '52px', maxWidth: '200px', objectFit: 'contain', display: 'block' }} />
                        </div>
                      )}
                      {submittedByName ? (
                        <div style={{ borderBottom: '1.5px solid #333', paddingBottom: '4px', marginBottom: '6px', fontSize: '15px', fontWeight: '700', color: '#024C9C' }}>{submittedByName}</div>
                      ) : (
                        <div style={{ borderBottom: '1.5px solid #333', paddingBottom: '4px', marginBottom: '6px', height: '24px' }} />
                      )}
                      {submittedBySpecialty && <div style={{ fontSize: '12px', color: '#555', marginBottom: '2px' }}>{submittedBySpecialty}</div>}
                      {submittedByPhone && <div style={{ fontSize: '12px', color: '#555', marginBottom: '2px' }}>Phone: {submittedByPhone}</div>}
                      <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Date: {moment().format('MMM DD, YYYY')}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#888' }}>
              <p style={{ fontSize: '15px' }}>Final Consultant Note has not been generated yet.</p>
            </div>
          )}
        </div>
      </div>

		</div>
	</div>
                    </div>
                </div>
                
              </div>
                 
             
      
      </div>
    
        </div>
         
         
        </div> 
      </div>


       {/* Modal Popup for Viewing Documents */}
       <Modal
       className='viewDocModal'
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Document Viewer"
       
      >
        <button
          onClick={closeModal}
          style={{
            float: 'right',
            cursor: 'pointer',
            background: 'red',
            color: 'white',
            border: 'none',
            padding: '4px 10px',
            borderRadius: '0px',
          }}
        >
          Close
        </button>
      
        {/* Ensure selectedDocument exists before rendering */}
        {selectedDocument ? (
          <>
            <h3>{selectedDocument.name}</h3>
            <embed src={selectedDocument} width="100%" height="100%" type="application/pdf"  className="innerContainer" />
            {/* Render PDF or Image based on file type */} 
          </>
        ) : (
          <p>Loading document...</p> // Fallback content if document is not available
        )}
      </Modal>

    </div>
  );
}

export default PatientHistory;
